export const SUCCESS_PROPERTY_TAGS="SUCCESS_PROPERTY_TAGS";
export const FAILED_PROPERTY_TAGS="FAILED_PROPERTY_TAGS";
export const REQUST_PROPERTY_TAGS="REQUST_PROPERTY_TAGS";
